define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/usersWithProfilesGridRowView.tmpl");
    var Loader = require("ui/loader/Loader");
    var PlusCompositeView = require("ui/plus-composite-view/PlusCompositeView");
    var ProfileModel = require("models/entities/ProfileModel");
    var Checkbox = require("ui/checkbox/Checkbox");

    var UsersGridRowView = {};

    var EMPTY_DATA = " ";

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UsersGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "user-row",
            template: template,
            ui: {
                selector: ".selector",
                displayName: ".display-name",
                userType: ".user-type",
                nickName: ".nick-name",
                loginName: ".login-name",
                groups: ".groups",
                skills: ".skills",
                lobs: ".lobs",
                profiles: ".profiles",
                roles: ".roles",
                groupsContent: ".groups .content",
                skillsContent: ".skills .content",
                lobsContent: ".lobs .content",
                skillsMismatchIcon: ".skills .mismatch-icon",
                profilesContent: ".profiles .content",
                rolesContent: ".roles .content"
            },
            uiComponents: {
                selectorCheckbox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.selector",
                        checked: false,
                        label: "",
                        permutation: Checkbox.PERMUTATION.B // no label
                    },
                    events: {
                        "change": "_onSelectorChange"
                    }
                }
            },
            events: {
                "click @ui.selector": "_onSelectorWrapperClick",
                "click @ui.displayName": "_onRowClick",
                "click @ui.userType": "_onRowClick",
                "click @ui.nickName": "_onRowClick",
                "click @ui.loginName": "_onRowClick",
                "click @ui.roles": "_onRowClick",
                "click @ui.profiles": "_onRowClick",
                "click @ui.groups": "_onRowClick",
                "click @ui.skills": "_onRowClick",
                "click @ui.lobs": "_onRowClick"
            },

            customTemplateHelpers: function() {
                var loginName = this.model.getLoginName();
                var nickName =  this.model.getNickName();
                var displayName =  this.model.getDisplayName();
                var userType = LE.translator.translate("LEUserManagement.userEdit.userType." + this.model.getUserTypeKey());

                return {
                    loginName: loginName,
                    userType: userType,
                    nickName:  nickName,
                    displayName: displayName
                };
            },

            initialize: function(options) {
                LEUserManagement.logger.debug("initialize", "UsersGridRowView:initialize");
                this.loaders = [];
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_LIST);
                this.agentGroupsCollection = LEUserManagement.getDataManager().getAgentGroupsCollection();
                this.groupColumnVisible = options.groupColumnVisible;
                this.userTypeColumnVisible = options.userTypeColumnVisible;
                this.lobsColumnVisible = options.lobsColumnVisible;
                this.gridModel = options.gridModel;
                this._bindEvents();
            },

            onRender: function() {
                LEUserManagement.logger.debug("onRender", "UsersGridRowView:onRender");
                this._updateRoles();
                this._updateProfiles();
                this._updateGroups();
                this._updateLobs();
                this._updateSkills();
                this._updateSkillsMismatch();
                this.showUserTypeColumn();
                this.showGroupsColumn();
                this.showLobsColumn();
            },
            onClose: function(){
                LEUserManagement.logger.debug("onClose", "UsersGridRowView:onClose");
            },

            _bindEvents: function (checked) {
                LEUserManagement.logger.debug("_bindEvents", "UsersGridRowView:_bindEvents");
                this.listenTo(this.model, "model:selection:change", this._onModelSelectionChange);

                this.listenTo(LEUserManagement.getDataManager().getAgentGroupsCollection(), "fetch:success", this._updateGroups);
                this.listenTo(LEUserManagement.getDataManager().getSkillsCollection(), "fetch:success", this._updateSkills);
                this.listenTo(LEUserManagement.getDataManager().getProfilesCollection(), "fetch:success", this._onProfilesFetchSuccess);
            },

            _onSelectorWrapperClick: function(e) {
                LEUserManagement.logger.debug("_onSelectorWrapperClick", "UsersGridRowView:_onSelectorWrapperClick");
                if ($(e.target).hasClass("selector")) {
                    this.uiComponents.selectorCheckbox.checkboxClick();
                }
            },

            _onRowClick: function() {
                LEUserManagement.logger.debug("_onRowClick", "UsersGridRowView:_onRowClick");
                this.channel.trigger("row:click", this.model);
            },

            _onSelectorChange: function(componentId, eventName, isChecked) {
                LEUserManagement.logger.debug("_onSelectorChange", "UsersGridRowView:_onSelectorChange");
                this.channel.trigger("row:selector:click", {itemModel:this.model, isChecked:isChecked});
            },

            _onModelSelectionChange: function(isChecked) {
                LEUserManagement.logger.debug("_onModelSelectionChange", "UsersGridRowView:_onModelSelectionChange");
                this.$el.toggleClass("selected", isChecked);
                this.uiComponents.selectorCheckbox.setCheckedState(isChecked);
            },

            showUserTypeColumn: function() {
                LEUserManagement.logger.debug("showUserTypeColumn", "UsersGridRowView:showUserTypeColumn");
                this.ui.userType.toggleClass("hide", !this.userTypeColumnVisible);
            },

            showGroupsColumn: function() {
                LEUserManagement.logger.debug("showGroupsColumn", "UsersGridRowView:showGroupsColumn");
                this.ui.groups.toggleClass("hide",!this.groupColumnVisible);
            },

            showLobsColumn: function() {
                LEUserManagement.logger.debug("showLobsColumn", "UsersGridRowView:showLobsColumn");
                this.ui.lobs.toggleClass("hide",!this.lobsColumnVisible);
            },

            _updateGroups: function() {
                LEUserManagement.logger.debug("_updateGroups", "UsersGridRowView:_updateGroups");
                if (this.uiComponents.groups) {
                    this.uiComponents.groups.close();
                }

                var groups = this.model.getGroups(this.agentGroupsCollection);

                if (groups && groups.length > 0) {
                    this.uiComponents.host$.createAndRender("groups", {
                        type: PlusCompositeView,
                        options: {
                            container: "view.ui.groupsContent",
                            collection: "view._getGroupsCollection",
                            textModelAttr: "tooltip",
                            visibleItemsCount: 1,
                            itemView: PlusCompositeView.DefaultPlusComponentItemView
                        }
                    });
                } else {
                    this.ui.groups.text(EMPTY_DATA);
                }
            },
            _updateSkills: function() {
                LEUserManagement.logger.debug("_updateSkills", "UsersGridRowView:_updateSkills");
                if (this.uiComponents.skills) {
                    this.uiComponents.skills.close();
                }

                var skills = this.model.getSkills();

                if (skills && skills.length > 0) {
                    this.uiComponents.host$.createAndRender("skills", {
                        type: PlusCompositeView,
                        options: {
                            container: "view.ui.skillsContent",
                            collection: "view._getSkillsCollection",
                            textModelAttr: "tooltip",
                            visibleItemsCount: 1,
                            itemView: PlusCompositeView.DefaultPlusComponentItemView
                        }
                    });
                } else {
                    this.ui.skills.text(EMPTY_DATA);
                }
            },

            _updateSkillsMismatch: function() {
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    var skillsCollection = LEUserManagement.getDataManager().getSkillsCollection();
                    var isMismatch = this.model.isMismatchLobsAndSkills(skillsCollection);
                    this.ui.skillsMismatchIcon.toggleClass("hide", !isMismatch);
                }
            },

            _updateLobs: function() {
                LEUserManagement.logger.debug("_updateLobs", "UsersGridRowView:_updateLobs");
                if (this.lobsColumnVisible) {
                    if (this.uiComponents.lobs) {
                        this.uiComponents.lobs.close();
                    }

                    var lobs = this.model.getLobs();

                    if (lobs && lobs.length > 0) {
                        this.uiComponents.host$.createAndRender("lobs", {
                            type: PlusCompositeView,
                            options: {
                                container: "view.ui.lobsContent",
                                collection: "view._getLobsCollection",
                                textModelAttr: "tooltip",
                                visibleItemsCount: 1,
                                itemView: PlusCompositeView.DefaultPlusComponentItemView
                            }
                        });
                    } else {
                        this.ui.lobs.text(EMPTY_DATA);
                    }
                }
            },

            _onProfilesFetchSuccess: function () {
                this._updateProfiles();
                this._updateRoles();
            },

            _updateProfiles: function() {
                LEUserManagement.logger.debug("_updateProfiles", "UsersGridRowView:_updateProfiles");
                if (this.uiComponents.profiles) {
                    this.uiComponents.profiles.close();
                }

                var profilesCollection = this._getProfilesCollection();
                var profiles = this.model.getProfiles();

                if (!LEUserManagement.getDataManager().getProfilesCollection().hasAtLeastOneSuccessfulFetch() && profilesCollection.size() === 0) {
                    this._showLoader("profiles", true);
                } else if (profiles && profiles.length > 0) {
                    this.uiComponents.host$.createAndRender("profiles", {
                        type: PlusCompositeView,
                        options: {
                            container: "view.ui.profilesContent",
                            collection: profilesCollection,
                            textModelAttr: "tooltip",
                            visibleItemsCount: 1,
                            itemView: PlusCompositeView.DefaultPlusComponentItemView
                        }
                    });
                    this._showLoader("profiles", false);
                }
            },
            _updateRoles: function() {
                LEUserManagement.logger.debug("_updateRoles", "UsersGridRowView:_updateRoles");
                if (this.uiComponents.roles) {
                    this.uiComponents.roles.close();
                }

                var rolesCollection = this._getRolesCollection();

                if (!LEUserManagement.getDataManager().getProfilesCollection().hasAtLeastOneSuccessfulFetch() && rolesCollection.size() === 0) {
                    this._showLoader("roles", true);
                } else if (0 < (this.model.getProfiles() || []).length) {
                    this.uiComponents.host$.createAndRender("roles", {
                        type: PlusCompositeView,
                        options: {
                            container: "view.ui.rolesContent",
                            collection: rolesCollection,
                            textModelAttr: "tooltip",
                            visibleItemsCount: 1,
                            itemView: PlusCompositeView.DefaultPlusComponentItemView
                        }
                    });
                    this._showLoader("roles", false);
                }
            },
            _getGroupsCollection: function() {
                LEUserManagement.logger.debug("_getGroupsCollection", "UsersGridRowView:_getGroupsCollection");
                var groups = this.model.getGroups(this.agentGroupsCollection);
                var groupsWIthToolTip = this._addToolTip(groups);
                return new PlusCompositeView.DefaultPlusComponentCollection(this._sortByName(groupsWIthToolTip));
            },
            _getSkillsCollection: function() {
                LEUserManagement.logger.debug("_getSkillsCollection", "UsersGridRowView:_getSkillsCollection");
                var skillIds = this.model.getSkills() || [];
                var skillsWIthToolTip = [];
                var skillsEntity = LEUserManagement.getDataManager().getEntities().SKILL;
                _.each(skillIds, function(skill) {
                    var skillName = LEUserManagement.getDataManager().getNameById(skillsEntity, skill);
                    if (skillName) {
                        skillsWIthToolTip.push({
                            name: skillName,
                            tooltip: skillName,
                            value: skill
                        });
                    }
                });
                return new PlusCompositeView.DefaultPlusComponentCollection(this._sortByName(skillsWIthToolTip));
            },
            _getLobsCollection: function() {
                LEUserManagement.logger.debug("_getLobsCollection", "UsersGridRowView:_getLobsCollection");
                var lobIds = this.model.getLobs() || [];
                var lobEntity = LEUserManagement.getDataManager().getEntities().LOB;
                var lobsArr = [];
                _.each(lobIds, function(lobId) {
                    var lobName = LEUserManagement.getDataManager().getNameById(lobEntity, lobId);
                    if (lobName) {
                        lobsArr.push({
                            name: lobName,
                            tooltip: lobName,
                            value: lobId
                        });
                    }
                });
                return new PlusCompositeView.DefaultPlusComponentCollection(this._sortByName(lobsArr));
            },
            _getProfilesCollection: function() {
                LEUserManagement.logger.debug("_getProfilesCollection", "UsersGridRowView:_getProfilesCollection");
                var profileIds = this.model.getProfiles() || [];
                var profilesWIthToolTip = [];
                var profilesEntity = LEUserManagement.getDataManager().getEntities().PROFILES;
                _.each(profileIds, function(profile) {
                    var profileName = LEUserManagement.getDataManager().getNameById(profilesEntity, profile);
                    if (profileName) {
                        profilesWIthToolTip.push({
                            name: profileName,
                            tooltip: profileName,
                            value: profile
                        });
                    }
                });
                return new PlusCompositeView.DefaultPlusComponentCollection(this._sortByName(profilesWIthToolTip));
            },
            _getRolesCollection: function() {
                LEUserManagement.logger.debug("_getRolesCollection", "UsersGridRowView:_getRolesCollection");
                var roles = [];
                var profileIds = this.model.getProfiles() || [];
                var profilesCollection = LEUserManagement.getDataManager().getProfilesCollection();
                _.each(profileIds, function(profile) {
                    if (profilesCollection.get(profile)) {
                        var roleId = profilesCollection.get(profile).getRoleTypeId();
                        roles.push({
                            name: LE.translator.translate(ProfileModel.ROLES_BY_IDS[roleId]),
                            tooltip: LE.translator.translate(ProfileModel.ROLES_BY_IDS[roleId]),
                            value: roleId
                        });
                    }
                });
                return new PlusCompositeView.DefaultPlusComponentCollection(this._sortByName(roles));
            },
            _addToolTip: function(items) {
                LEUserManagement.logger.debug("_addToolTip", "UsersGridRowView:_addToolTip");
                for (var ii = 0; ii < items.length; ii++) {
                    if (items[ii].name) {
                        items[ii].tooltip = items[ii].name;
                    }
                    else if (items[ii].key) {
                        items[ii].tooltip = items[ii].key;
                    }
                }
                return items;
            },

            _sortByName: function(items) {
                items.sort(function(a, b){
                    return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                });

                return items;
            },

            _showLoader:function (clmName, show) {
                if (show && this.ui[clmName].find(".content").length && this.ui[clmName].find(".loading").length && !this.loaders[clmName]) {
                    this.ui[clmName].find(".content").html("");
                    this.loaders[clmName] = new Loader({
                        permutation:Loader.PERMUTATION.H,
                        el:this.ui[clmName].find(".loading")
                    });
                    this.loaders[clmName].render();
                }
                else {
                    if (this.loaders[clmName]) {
                        this.loaders[clmName].close();
                        this.loaders[clmName] = null;
                    }
                    this.ui[clmName].find(".loading").toggleClass("loading", show);
                }
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UsersGridRowView;
});
